import { handleUniversalLoginRedirection } from '@/home/router/guards';

const HomePage = () => import('@/home/pages/home.vue');

export const homeRoutes = [
  {
    path: '',
    name: 'home',
    component: HomePage,
    beforeEnter: [handleUniversalLoginRedirection],
  },
];
